import Vue from "vue";
import { functions } from "@/firebase";
import env from "@/env";
import router from "../router";
import { delay } from "@/helpers/helpers";

// eslint-disable-next-line no-undef
const stripe = Stripe(env.stripe.key);

const STRIPE_DELAY = 3000;

const getStripeSession = functions.httpsCallable("getStripeSession");
const createSaasCheckoutSession = functions.httpsCallable(
  "createSaasCheckoutSession"
);
const confirmSaasCheckout = functions.httpsCallable("confirmSaasCheckout");
const startSaasTrial = functions.httpsCallable("startSaasTrial");

const cancelSubscription = functions.httpsCallable("cancelSubscription");

const changeSubscriptionPreview = functions.httpsCallable(
  "changeSubscriptionPreview"
);

const changeSubscription = functions.httpsCallable("changeSubscription");

const changeCardDetails = functions.httpsCallable("getStripeSessionExistingCC");

const connectStripeAccount = functions.httpsCallable("connectStripeAccount");

const disconnectStripeAccount = functions.httpsCallable(
  "disconnectStripeAccount"
);

const getStripeSessionPayNow = functions.httpsCallable(
  "getStripeSessionPayNow"
);

const getPaymentSummary = functions.httpsCallable("getPaymentSummary");

const triggerStripeRefund = functions.httpsCallable("triggerStripeRefund");

const mutationTypes = {
  SET_PAYMENT_SUMMARY: "SET_PAYMENT_SUMMARY"
};

const state = {
  paymentSummary: null
  // paymentSummary: {
  //   number: "INV0000005",
  //   total: 200,
  //   companyName: "Advanced Cloud Services Ltd"
  // }
};

const getters = {
  paymentSummary: state => state.paymentSummary
};

const actions = {
  async startSaasCheckout(_context, urls) {
    const response = await createSaasCheckoutSession({
      success_url: urls && urls.success_url,
      cancel_url: urls && urls.cancel_url
    });
    const sessionId = response && response.data && response.data.id;
    if (!sessionId) {
      throw new Error("Could not start card checkout.");
    }
    const result = await stripe.redirectToCheckout({ sessionId });
    if (result && result.error) {
      throw result.error;
    }
    return result;
  },
  async confirmSaasCheckout(_context, sessionId) {
    return confirmSaasCheckout({ sessionId });
  },
  async startSaasTrial() {
    return startSaasTrial();
  },
  async fetchStripeSession(context, planId) {
    const redirectUrl = `${window.location.href.replace(
      window.location.hash,
      "#/account"
    )}?session_id={CHECKOUT_SESSION_ID}&create_subscription=true`;

    const response = await getStripeSession({
      plan: planId,
      params: {
        success_url: redirectUrl + "&success=true",
        cancel_url: redirectUrl + "&cancel=true"
      }
    });
    stripe
      .redirectToCheckout({ sessionId: response.data.id })
      .then(function(result) {
        // If `redirectToCheckout` fails due to a browser or network
        // error, display the localized error message to your customer
        // using `result.error.message`.
      });
  },
  async cancelSubscription(context) {
    await cancelSubscription();
    await delay(STRIPE_DELAY);
    context.dispatch("fetchSubscription");
  },
  changeSubscriptionPreview(context, plan) {
    return changeSubscriptionPreview({ plan });
  },
  async changeSubscription(context, plan) {
    await changeSubscription({ plan });
    await delay(STRIPE_DELAY);
    context.dispatch("fetchSubscription");
  },
  async changeCardDetails(context) {
    const redirectUrl = `${window.location.href.replace(
      window.location.hash,
      "#/account"
    )}?session_id={CHECKOUT_SESSION_ID}&change_card_details=true`;

    const response = await changeCardDetails({
      params: {
        success_url: redirectUrl + "&success=true",
        cancel_url: redirectUrl + "&cancel=true"
      }
    });

    const stripeResponse = await stripe.redirectToCheckout({
      sessionId: response.data.id
    });

    if (stripeResponse.error) {
      throw stripeResponse.error;
    }

    return stripeResponse;
  },
  async connectWithStripe(context, args) {
    await connectStripeAccount(args);
    await delay(STRIPE_DELAY);
    context.dispatch("fetchUserSettings");
  },
  async disconnectFromStripe(context) {
    await disconnectStripeAccount();
    await delay(STRIPE_DELAY);
    context.dispatch("fetchUserSettings");
  },
  async getStripeSessionPayNow(context, token) {
    const redirectUrl = window.location.href.replace(
      window.location.hash,
      "#/payment-summary?token=" + encodeURIComponent(token)
    );

    const response = await getStripeSessionPayNow({
      token,
      params: {
        success_url: redirectUrl + "&success=true",
        cancel_url: redirectUrl + "&failure=true"
      }
    });

    const { isPayable, accountId, sessionId } = response.data;

    if (!isPayable || !accountId || !sessionId) return router.push("/");

    var _stripe = Stripe(env.stripe.key, {
      stripeAccount: accountId
    });

    try {
      await _stripe.redirectToCheckout({ sessionId });
    } catch ({ error }) {
      // If `redirectToCheckout` fails due to a browser or network
      // error, display the localized error message to your customer
      // using `result.error.message`.
      context.commit(mutationTypes.SET_PAYMENT_SUMMARY, null);
      return error;
    }
  },
  async getPaymentSummary(context, token) {
    const response = await getPaymentSummary({ token });
    context.commit("SET_PAYMENT_SUMMARY", response.data);
  },
  async triggerStripeRefund(context, args) {
    await triggerStripeRefund(args);
  }
};

const mutations = {
  [mutationTypes.SET_PAYMENT_SUMMARY](state, payload) {
    Vue.set(state, "paymentSummary", payload);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
